<div class="w-full max-w-6xl mx-auto p-6">
  @if (loading() && !mandate()) {
    <div class="bg-white rounded-xl border border-slate-200 p-6 flex flex-col gap-3">
      <p-skeleton width="12rem" height="1.5rem" />
      <p-skeleton width="100%" height="6rem" />
      <p-skeleton width="100%" height="10rem" />
    </div>
  } @else if (notFound()) {
    <div class="bg-white rounded-xl border border-slate-200 p-10 text-center">
      <p class="text-slate-700 font-medium m-0">No se encontró el mandato.</p>
      <a routerLink="/mit-mandates" class="text-sm text-sky-700 hover:underline">Volver a Mandatos</a>
    </div>
  } @else if (mandate(); as m) {
    @if (statusReason()) {
      <div class="border rounded-lg p-4 mb-6 flex items-start gap-3" [ngClass]="statusChipClass().chip" role="status">
        <i class="pi pi-info-circle mt-0.5 shrink-0" [ngClass]="statusChipClass().label" aria-hidden="true"></i>
        <div class="min-w-0 flex-1">
          <p class="font-medium m-0" [ngClass]="statusChipClass().value">Mandato {{ statusLabel().toLowerCase() }}</p>
          <p class="mt-1 text-sm m-0 whitespace-pre-wrap break-words" [ngClass]="statusChipClass().value">{{ statusReason() }}</p>
        </div>
      </div>
    }

    @if (validityNotice(); as notice) {
      <div class="border border-sky-200 bg-sky-50 rounded-lg p-4 mb-6 flex items-start gap-3" role="status">
        <i class="pi pi-calendar-clock text-sky-600 mt-0.5 shrink-0" aria-hidden="true"></i>
        <div class="min-w-0 flex-1">
          <p class="font-medium m-0 text-sky-800">{{ notice.title }}</p>
          <p class="mt-1 text-sm m-0 text-sky-800">
            {{ notice.detail }}
            Vigencia: {{ m.validFrom ? (m.validFrom | date:'dd/MM/yyyy HH:mm') : 'desde su activación' }}
            — {{ m.validUntil ? (m.validUntil | date:'dd/MM/yyyy HH:mm') : 'sin fin' }}.
          </p>
        </div>
      </div>
    }

    <p-card styleClass="sale-form-card">
      <ng-template pTemplate="header">
        <div class="px-4 py-3 border-b border-slate-200 bg-slate-50/50">
          <div class="flex items-center justify-between gap-3">
            <div class="flex items-center gap-3 min-w-0">
              <p-button
                icon="pi pi-arrow-left"
                [rounded]="true"
                [text]="true"
                severity="secondary"
                type="button"
                (onClick)="back()"
                pTooltip="Volver al listado"
                tooltipPosition="bottom"
              />
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2 min-w-0 m-0">
                <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <mat-icon>handshake</mat-icon>
                </span>
                <span class="truncate">Mandato {{ m.number }}</span>
              </h2>
            </div>
            <p-button
              icon="pi pi-refresh"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              type="button"
              (onClick)="reload()"
              [loading]="loading()"
              [disabled]="loading()"
              pTooltip="Actualizar mandato"
              tooltipPosition="bottom"
            />
          </div>
        </div>
        <div class="flex flex-wrap items-center justify-between gap-2 border-b border-slate-200 bg-slate-50/90 px-3 py-2">
          <div class="flex min-w-0 flex-wrap items-center gap-2">
            <div class="inline-flex min-w-0 items-baseline gap-x-2 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5">
              <span class="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Folio</span>
              <span class="text-sm font-semibold tabular-nums tracking-tight text-slate-900">{{ m.number }}</span>
            </div>
            <div class="inline-flex items-baseline gap-x-1.5 rounded-lg border px-2.5 py-1.5" [ngClass]="statusChipClass().chip">
              <span class="text-[11px] font-semibold tracking-wider" [ngClass]="statusChipClass().label">STATUS:</span>
              <span class="text-sm font-medium font-mono" [ngClass]="statusChipClass().value">{{ statusLabel() }}</span>
            </div>
          </div>

          @if (hasToolbarAction()) {
            <div class="flex flex-wrap items-center justify-end gap-1.5" role="toolbar" aria-label="Acciones del mandato">
              @if (actions().resendEnrollmentLink) {
                <button
                  type="button"
                  class="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200/80 bg-white px-2 text-xs font-medium text-slate-700 shadow-sm transition hover:border-sky-300 hover:bg-sky-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-sky-400 disabled:pointer-events-none disabled:opacity-40"
                  (click)="resendEnrollmentLink()"
                  [disabled]="linkLoading()"
                  pTooltip="Reenviar la liga al correo del cliente"
                  tooltipPosition="bottom"
                >
                  <i class="pi text-sky-600 text-sm" [ngClass]="linkLoading() ? 'pi-spinner pi-spin' : 'pi-send'"></i>
                  <span class="hidden sm:inline">Reenviar liga</span>
                </button>
              }
              @if (actions().enrollmentLink) {
                <button
                  type="button"
                  class="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200/80 bg-white px-2 text-xs font-medium text-slate-700 shadow-sm transition hover:border-sky-300 hover:bg-sky-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-sky-400 disabled:pointer-events-none disabled:opacity-40"
                  (click)="linkOpen.set(true)"
                  pTooltip="Generar una nueva liga de registro"
                  tooltipPosition="bottom"
                >
                  <i class="pi pi-link text-sky-600 text-sm"></i>
                  <span class="hidden sm:inline">Regenerar liga</span>
                </button>
              }
              @if (actions().resendManageLink) {
                <button
                  type="button"
                  class="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200/80 bg-white px-2 text-xs font-medium text-slate-700 shadow-sm transition hover:border-sky-300 hover:bg-sky-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-sky-400 disabled:pointer-events-none disabled:opacity-40"
                  (click)="resendManageLink()"
                  [disabled]="manageLinkLoading()"
                  pTooltip="Enviar al cliente su liga para consultar cargos, cambiar su tarjeta o revocar"
                  tooltipPosition="bottom"
                >
                  <i class="pi text-sky-600 text-sm" [ngClass]="manageLinkLoading() ? 'pi-spinner pi-spin' : 'pi-envelope'"></i>
                  <span class="hidden sm:inline">Reenviar liga de gestión</span>
                </button>
              }
              @if (actions().suspend) {
                <button
                  type="button"
                  class="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200/80 bg-white px-2 text-xs font-medium text-slate-700 shadow-sm transition hover:border-amber-300 hover:bg-amber-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-amber-400 disabled:pointer-events-none disabled:opacity-40"
                  (click)="statusAction.set('suspend')"
                  pTooltip="Suspender mandato"
                  tooltipPosition="bottom"
                >
                  <i class="pi pi-pause text-amber-600 text-sm"></i>
                  <span class="hidden sm:inline">Suspender</span>
                </button>
              }
              @if (actions().reactivate) {
                <button
                  type="button"
                  class="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200/80 bg-white px-2 text-xs font-medium text-slate-700 shadow-sm transition hover:border-emerald-300 hover:bg-emerald-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-emerald-400 disabled:pointer-events-none disabled:opacity-40"
                  (click)="statusAction.set('reactivate')"
                  pTooltip="Reactivar mandato"
                  tooltipPosition="bottom"
                >
                  <i class="pi pi-play text-emerald-600 text-sm"></i>
                  <span class="hidden sm:inline">Reactivar</span>
                </button>
              }
              @if (actions().revoke) {
                <button
                  type="button"
                  class="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200/80 bg-white px-2 text-xs font-medium text-slate-700 shadow-sm transition hover:border-rose-300 hover:bg-rose-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-rose-400 disabled:pointer-events-none disabled:opacity-40"
                  (click)="statusAction.set('revoke')"
                  pTooltip="Revocar mandato"
                  tooltipPosition="bottom"
                >
                  <i class="pi pi-ban text-rose-600 text-sm"></i>
                  <span class="hidden sm:inline">Revocar</span>
                </button>
              }
            </div>
          }
        </div>
      </ng-template>

      <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)">
        <p-tablist>
          <p-tab value="general" class="flex items-center gap-2! text-inherit">
            <i class="pi pi-file"></i>
            <span>General</span>
          </p-tab>
          <p-tab value="transactions" class="flex items-center gap-2! text-inherit">
            <i class="pi pi-credit-card"></i>
            <span>Transacciones</span>
            @if (transactionsTotal()) {
              <span class="rounded-full bg-slate-100 px-1.5 text-[11px] font-semibold text-slate-600">{{ transactionsTotal() }}</span>
            }
          </p-tab>
          <p-tab value="consents" class="flex items-center gap-2! text-inherit">
            <i class="pi pi-verified"></i>
            <span>Consentimientos</span>
            @if (m.consents?.length) {
              <span class="rounded-full bg-slate-100 px-1.5 text-[11px] font-semibold text-slate-600">{{ m.consents?.length }}</span>
            }
          </p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="general">
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 py-4">
              <!-- Datos del mandato -->
              <div class="lg:col-span-3">
                <h3 class="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
                  <i class="pi pi-file-edit"></i>
                  Datos del mandato
                </h3>
                <dl class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3 text-sm m-0">
                  <div>
                    <dt class="text-xs text-slate-500">Cliente</dt>
                    <dd class="m-0 text-slate-900">
                      <a [routerLink]="['/customers', m.customerId]" class="hover:underline">{{ m.customerName }}</a>
                      <span class="block text-xs text-slate-500">{{ m.customerEmail }}</span>
                    </dd>
                  </div>
                  <div>
                    <dt class="text-xs text-slate-500">Propósito</dt>
                    <dd class="m-0 text-slate-900">{{ m.purpose }}</dd>
                  </div>
                  <div>
                    <dt class="text-xs text-slate-500">Referencia externa</dt>
                    <dd class="m-0 text-slate-900 flex items-center gap-1.5">
                      <span class="font-mono">{{ m.externalReference || '—' }}</span>
                      @if (m.externalReference) {
                        <button
                          type="button"
                          class="text-slate-400 hover:text-sky-600 transition"
                          (click)="copyReference(m.externalReference)"
                          pTooltip="Copiar referencia externa"
                          tooltipPosition="top"
                          aria-label="Copiar referencia externa"
                        >
                          <i class="pi pi-copy text-xs"></i>
                        </button>
                      }
                    </dd>
                  </div>
                  <div>
                    <dt class="text-xs text-slate-500">Tarjeta</dt>
                    <dd class="m-0 text-slate-900">
                      @if (m.card?.lastDigits) {
                        {{ m.card?.brand || 'Tarjeta' }} <span class="font-mono">•••• {{ m.card?.lastDigits }}</span>
                      } @else {
                        <span class="text-slate-500">Sin registrar</span>
                      }
                    </dd>
                  </div>
                  @if (m.card?.lastDigits) {
                    <div>
                      <dt class="text-xs text-slate-500">Tipo de tarjeta</dt>
                      <dd class="m-0 text-slate-900">{{ m.card?.type || '—' }}</dd>
                    </div>
                    <div>
                      <dt class="text-xs text-slate-500">Vencimiento de tarjeta</dt>
                      <dd class="m-0 flex items-center gap-1.5" [ngClass]="cardExpiresSoon() ? 'text-amber-700 font-semibold' : 'text-slate-900'">
                        {{ m.card?.expirationMonth }}/{{ m.card?.expirationYear }}
                        @if (cardExpiresSoon()) {
                          <i
                            class="pi pi-exclamation-triangle text-xs text-amber-600"
                            pTooltip="La tarjeta vence en menos de 30 días. Reenvía la liga de gestión para que el cliente registre otra."
                            tooltipPosition="top"
                          ></i>
                        }
                      </dd>
                    </div>
                  }
                  <div>
                    <dt class="text-xs text-slate-500">Vigencia</dt>
                    <dd class="m-0 text-slate-900">
                      {{ m.validFrom ? (m.validFrom | date:'dd/MM/yyyy HH:mm') : 'Desde su activación' }}
                      — {{ m.validUntil ? (m.validUntil | date:'dd/MM/yyyy HH:mm') : 'sin fin' }}
                    </dd>
                  </div>
                  <div>
                    <dt class="text-xs text-slate-500">Alta</dt>
                    <dd class="m-0 text-slate-900">{{ m.createdAt | date:'dd/MM/yyyy HH:mm' }}</dd>
                  </div>
                  @if (m.activatedAt) {
                    <div>
                      <dt class="text-xs text-slate-500">Activado</dt>
                      <dd class="m-0 text-slate-900">{{ m.activatedAt | date:'dd/MM/yyyy HH:mm' }}</dd>
                    </div>
                  }
                  @if (m.suspendedAt && m.status === 'SUSPENDED') {
                    <div>
                      <dt class="text-xs text-slate-500">Suspendido</dt>
                      <dd class="m-0 text-slate-900">{{ m.suspendedAt | date:'dd/MM/yyyy HH:mm' }}</dd>
                    </div>
                  }
                  @if (m.revokedAt) {
                    <div>
                      <dt class="text-xs text-slate-500">Revocado</dt>
                      <dd class="m-0 text-slate-900">{{ m.revokedAt | date:'dd/MM/yyyy HH:mm' }}</dd>
                    </div>
                  }
                  @if (m.status === 'PENDING_ENROLLMENT') {
                    <div>
                      <dt class="text-xs text-slate-500">Cargo de registro</dt>
                      <dd class="m-0 text-slate-900">
                        @if (m.initialCharge; as initialCharge) {
                          Primer cobro {{ initialCharge.amount | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }} · {{ initialCharge.concept }}
                          <ul class="m-0 mt-1 pl-4 text-xs text-slate-600">
                            @for (line of initialCharge.lines ?? []; track $index) {
                              <li>
                                {{ line.quantity }} × {{ line.description }} · {{ line.unitPrice | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }} sin impuestos
                                @if (line.totalAmount != null) {
                                  · total {{ line.totalAmount | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}
                                }
                              </li>
                            }
                          </ul>
                        } @else {
                          Validación que se cancela de inmediato; no genera venta
                        }
                      </dd>
                    </div>
                    <div>
                      <dt class="text-xs text-slate-500">Liga de registro</dt>
                      <dd class="m-0 text-slate-900">
                        Vence {{ m.enrollmentExpiresAt | date:'dd/MM/yyyy HH:mm' }} · {{ m.enrollmentAttempts ?? 0 }} intento(s)
                      </dd>
                    </div>
                  }
                  @if (actions().resendEnrollmentLink && m.enrollmentLinkSentAt) {
                    <div class="sm:col-span-2">
                      <dt class="text-xs text-slate-500">{{ m.enrollmentPurpose === 'CARD_REPLACEMENT' ? 'Liga de reemplazo de tarjeta' : 'Liga de registro' }}</dt>
                      <dd class="m-0 text-slate-900">
                        Enviada a <span class="font-medium">{{ m.customerEmail }}</span> el {{ m.enrollmentLinkSentAt | date:'dd/MM/yyyy HH:mm' }}
                      </dd>
                      <p class="text-[11px] text-slate-500 m-0 mt-1">
                        Por seguridad, solo el cliente recibe la liga. Vence el {{ m.enrollmentExpiresAt | date:'dd/MM/yyyy HH:mm' }}.
                      </p>
                    </div>
                  }
                  @if ((m.consecutiveDeclines ?? 0) > 0) {
                    <div>
                      <dt class="text-xs text-slate-500">Declinaciones seguidas</dt>
                      <dd class="m-0 text-slate-900">{{ m.consecutiveDeclines }} de {{ m.limits?.maxConsecutiveDeclines ?? 3 }}</dd>
                    </div>
                  }
                </dl>
              </div>

              <div class="lg:col-span-3">
                <app-mit-comercial-metadata-view [metadata]="m.comercialMetadata"
                  hint="Se envía a Paycode en cada cargo del mandato; cada cobro puede agregar o reemplazar llaves." />
              </div>

              <div class="lg:col-span-3 flex flex-col gap-4">
                @if (m.pendingLimits) {
                  <p class="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2 m-0">
                    <span class="font-semibold">Aumento de límites pendiente.</span>
                    El cliente debe aceptar los límites propuestos antes del {{ m.pendingLimitsExpiresAt | date:'dd/MM/yyyy HH:mm' }}.
                    Mientras tanto aplican los vigentes.
                  </p>
                }

                <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                  <!-- Límites -->
                  <div>
                    <div class="flex items-center justify-between gap-2 mb-4 min-h-7">
                      <h3 class="text-lg font-semibold text-slate-900 flex items-center gap-2 m-0">
                        <i class="pi pi-sliders-h"></i>
                        Límites
                      </h3>
                      <div class="flex items-center gap-2">
                        @if (m.pendingLimits) {
                          <p-tag severity="warn" value="Aumento pendiente" />
                        }
                        @if (canWrite && actions().changeLimits) {
                          <button
                            type="button"
                            class="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200/80 bg-white px-2 text-xs font-medium text-slate-700 shadow-sm transition hover:border-sky-300 hover:bg-sky-50 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-sky-400"
                            (click)="limitsOpen.set(true)"
                          >
                            <i class="pi pi-sliders-h text-sky-600 text-sm"></i>
                            Cambiar límites
                          </button>
                        }
                      </div>
                    </div>
                    <div class="rounded-lg border border-slate-200 overflow-hidden">
                      <table class="w-full text-sm">
                        <thead class="bg-slate-50 border-b border-slate-200">
                          <tr>
                            <th class="px-4 py-2.5 text-left text-xs font-semibold text-slate-700 uppercase">Límite</th>
                            <th class="px-4 py-2.5 text-right text-xs font-semibold text-slate-700 uppercase">Vigente</th>
                            @if (m.pendingLimits) {
                              <th class="px-4 py-2.5 text-right text-xs font-semibold text-slate-700 uppercase">Propuesto</th>
                            }
                          </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-200">
                          @for (row of limitRows; track row.key) {
                            <tr class="hover:bg-slate-50 h-10">
                              <td class="px-4 py-2 text-slate-600">{{ row.label }}</td>
                              <td class="px-4 py-2 text-right text-slate-900 tabular-nums whitespace-nowrap">{{ limitValue(row, m.limits) }}</td>
                              @if (m.pendingLimits) {
                                <td class="px-4 py-2 text-right tabular-nums whitespace-nowrap" [class.font-semibold]="limitChanged(row)" [class.text-amber-700]="limitChanged(row)">
                                  {{ limitValue(row, m.pendingLimits) }}
                                </td>
                              }
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Consumo -->
                  <div>
                    <div class="flex items-center justify-between gap-2 mb-4 min-h-7">
                      <h3 class="text-lg font-semibold text-slate-900 flex items-center gap-2 m-0">
                        <i class="pi pi-chart-bar"></i>
                        Consumo
                      </h3>
                      <span class="text-xs text-slate-500">Día y mes calendario, hora del centro de México</span>
                    </div>
                    <div class="rounded-lg border border-slate-200 overflow-hidden">
                      <table class="w-full text-sm">
                        <thead class="bg-slate-50 border-b border-slate-200">
                          <tr>
                            <th class="px-4 py-2.5 text-left text-xs font-semibold text-slate-700 uppercase">Concepto</th>
                            <th class="px-4 py-2.5 text-left text-xs font-semibold text-slate-700 uppercase w-3/5">Consumido / Límite</th>
                          </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-200">
                          @for (bar of usageBars(); track bar.label) {
                            <tr class="hover:bg-slate-50">
                              <td class="px-4 py-2 text-slate-600">{{ bar.label }}</td>
                              <td class="px-4 py-2">
                                <div class="flex items-baseline justify-between gap-2 text-xs tabular-nums mb-1">
                                  <span class="whitespace-nowrap">
                                    <span class="font-semibold text-slate-900">
                                      @if (bar.kind === 'amount') {
                                        {{ bar.used | currency:'MXN':'symbol-narrow' }}
                                      } @else {
                                        {{ bar.used }}
                                      }
                                    </span>
                                    <span class="text-slate-500">
                                      @if (!bar.limit) {
                                        · Sin límite
                                      } @else if (bar.kind === 'amount') {
                                        de {{ bar.limit | currency:'MXN':'symbol-narrow' }}
                                      } @else {
                                        de {{ bar.limit }}
                                      }
                                    </span>
                                  </span>
                                  @if (bar.limit) {
                                    <span class="text-slate-500">{{ barPercent(bar) }}%</span>
                                  }
                                </div>
                                <p-progressbar [value]="bar.limit ? barPercent(bar) : 0" [showValue]="false" styleClass="!h-2" />
                              </td>
                            </tr>
                          } @empty {
                            <tr>
                              <td colspan="2" class="px-4 py-6 text-center text-slate-500">Sin consumo registrado.</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </p-tabpanel>

          <p-tabpanel value="transactions">
            <div class="py-4">
              <div class="flex items-center justify-between mb-4">
                <h3 class="text-lg font-semibold text-slate-900 flex items-center gap-2 m-0">
                  <i class="pi pi-credit-card"></i>
                  Transacciones
                </h3>
                <p-button
                  label="Actualizar"
                  icon="pi pi-refresh"
                  type="button"
                  (onClick)="reload()"
                  [loading]="transactionsLoading()"
                  [disabled]="transactionsLoading()"
                  pTooltip="Actualiza el mandato y sus transacciones"
                  severity="secondary"
                  [rounded]="true"
                />
              </div>
              <div class="rounded-lg border border-slate-200 overflow-hidden">
                <p-table
                  [value]="transactions()"
                  dataKey="id"
                  [lazy]="true"
                  [paginator]="transactionsTotal() > transactionsSize"
                  [rows]="transactionsSize"
                  [first]="transactionsPage() * transactionsSize"
                  [totalRecords]="transactionsTotal()"
                  [loading]="transactionsLoading()"
                  (onLazyLoad)="onTransactionsLazyLoad($event)"
                  styleClass="p-datatable-sm"
                  [rowHover]="true">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="!text-xs !font-semibold !text-slate-700 uppercase">Fecha</th>
                      <th class="!text-xs !font-semibold !text-slate-700 uppercase">Tipo</th>
                      <th class="!text-xs !font-semibold !text-slate-700 uppercase">Estado</th>
                      <th class="!text-xs !font-semibold !text-slate-700 uppercase">Concepto</th>
                      <th class="!text-xs !font-semibold !text-slate-700 uppercase hidden md:table-cell">Referencia</th>
                      <th class="!text-xs !font-semibold !text-slate-700 uppercase !text-right">Monto</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-tx>
                    <tr [class.cursor-pointer]="canReadTransactions" (click)="openTransaction(tx)">
                      <td class="!text-sm whitespace-nowrap">{{ tx.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
                      <td class="!text-sm">{{ txTypeLabel(tx.type) }}</td>
                      <td class="!text-sm">
                        <p-tag class="!text-xs" [severity]="txSeverity(tx.status)" [value]="txStatusLabel(tx.status)" />
                        @if (txDetail(tx)) {
                          <span class="block text-[11px] text-slate-500 mt-0.5">{{ txDetail(tx) }}</span>
                        }
                      </td>
                      <td class="!text-sm max-w-[16rem] truncate">{{ tx.concept }}</td>
                      <td class="!text-sm hidden md:table-cell">{{ tx.externalReference || '—' }}</td>
                      <td class="!text-sm !text-right whitespace-nowrap">{{ tx.amount | currency:(tx.currencyCode || 'MXN'):'symbol-narrow' }}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr><td colspan="6" class="!text-center !text-slate-500 !py-6">Sin transacciones.</td></tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </p-tabpanel>

          <p-tabpanel value="consents">
            <div class="py-4">
              <h3 class="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
                <i class="pi pi-verified"></i>
                Consentimientos del cliente
              </h3>
              @if (m.consents?.length) {
                <div class="rounded-lg border border-slate-200 overflow-hidden overflow-x-auto">
                  <table class="w-full text-sm">
                    <thead class="bg-slate-50 border-b border-slate-200">
                      <tr>
                        <th class="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase whitespace-nowrap">Tipo</th>
                        <th class="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase whitespace-nowrap">Fecha</th>
                        <th class="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase whitespace-nowrap hidden sm:table-cell">Términos</th>
                        <th class="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase whitespace-nowrap hidden sm:table-cell">IP</th>
                        <th class="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase whitespace-nowrap">Tarjeta</th>
                        <th class="px-4 py-3 w-10"></th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-200">
                      @for (consent of m.consents; track consent.id) {
                        <tr class="hover:bg-slate-50 cursor-pointer" (click)="openConsent(consent)">
                          <td class="px-4 py-3 text-slate-900">{{ consentLabel(consent.type) }}</td>
                          <td class="px-4 py-3 text-slate-600 whitespace-nowrap">{{ consent.acceptedAt | date:'dd/MM/yyyy HH:mm' }}</td>
                          <td class="px-4 py-3 text-slate-600 hidden sm:table-cell">
                            <span [pTooltip]="consent.termsTextSha256" tooltipPosition="top">{{ consent.termsVersion }}</span>
                          </td>
                          <td class="px-4 py-3 text-slate-600 hidden sm:table-cell">{{ consent.ipAddress || '—' }}</td>
                          <td class="px-4 py-3 text-slate-600">{{ consent.cardLastDigits ? '•••• ' + consent.cardLastDigits : '—' }}</td>
                          <td class="px-4 py-3 text-right">
                            <button
                              type="button"
                              class="inline-flex h-7 w-7 items-center justify-center rounded-md text-sky-600 hover:bg-sky-50 hover:text-sky-800"
                              (click)="openConsent(consent); $event.stopPropagation()"
                              pTooltip="Ver lo aprobado"
                              tooltipPosition="left"
                              aria-label="Ver detalle del consentimiento">
                              <i class="pi pi-eye text-xs"></i>
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              } @else {
                <p class="text-slate-500 py-6 m-0">Sin consentimientos registrados todavía.</p>
              }
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>

      <ng-template pTemplate="footer">
        <div class="!mt-4 flex justify-end gap-4 mt-1 !p-4 !-m-5 bg-gray-50 p-2 border-t border-slate-200">
          <p-button label="Volver" severity="secondary" (onClick)="back()" type="button" />
          @if (canCharge && actions().charge) {
            <p-button label="Cobrar" icon="pi pi-credit-card" (onClick)="chargeOpen.set(true)" type="button" />
          }
        </div>
      </ng-template>
    </p-card>
  }
</div>

<app-mit-mandate-status-dialog
  [mandate]="mandate()"
  [action]="statusAction()"
  (closed)="statusAction.set(null)"
  (changed)="onMandateChanged($event)" />

<app-mit-mandate-limits-dialog
  [mandate]="mandate()"
  [visible]="limitsOpen()"
  (closed)="limitsOpen.set(false)"
  (changed)="onMandateChanged($event)" />

<app-mit-mandate-link-dialog
  [mandate]="mandate()"
  [visible]="linkOpen()"
  (closed)="linkOpen.set(false)"
  (changed)="onMandateChanged($event)" />

<app-mit-charge-dialog
  [mandate]="mandate()"
  [visible]="chargeOpen()"
  (closed)="chargeOpen.set(false)"
  (charged)="onCharged()" />

<p-drawer
  [visible]="consentOpen()"
  position="right"
  (visibleChange)="onConsentDrawerVisibleChange($event)"
  styleClass="mit-consent-details-drawer !w-[800px]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center gap-3 min-w-0">
      <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600 shadow-sm">
        <i class="pi pi-verified text-base"></i>
      </span>
      <div class="min-w-0">
        <h3 class="text-lg font-semibold text-slate-900">Detalle del consentimiento</h3>
        @if (mandate()?.number) {
          <p class="text-xs text-slate-500">Mandato {{ mandate()?.number }}</p>
        }
      </div>
    </div>
  </ng-template>
  @if (consentLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
      <p class="text-sm text-slate-600">Cargando consentimiento...</p>
    </div>
  } @else if (selectedConsent()) {
    <app-mit-consent-read [consent]="selectedConsent()!" />
  }
</p-drawer>
